import React from 'react'
import AddStartpageComToYourHomeScreen from '../add-startpage-com-to-your-home-screen'

const AddStartpageComToYourHomeScreenEs = () => {
    return <AddStartpageComToYourHomeScreen languageCode="es" />
}

export default AddStartpageComToYourHomeScreenEs
